var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 1.3335H6C5.26467 1.3335 4.66667 1.9315 4.66667 2.66683V6.66683H3.33333C2.598 6.66683 2 7.26483 2 8.00016V14.0002C2 14.177 2.07024 14.3465 2.19526 14.4716C2.32029 14.5966 2.48986 14.6668 2.66667 14.6668H13.3333C13.5101 14.6668 13.6797 14.5966 13.8047 14.4716C13.9298 14.3465 14 14.177 14 14.0002V2.66683C14 1.9315 13.402 1.3335 12.6667 1.3335ZM3.33333 8.00016H7.33333V13.3335H3.33333V8.00016ZM12.6667 13.3335H8.66667V8.00016C8.66667 7.26483 8.06867 6.66683 7.33333 6.66683H6V2.66683H12.6667V13.3335Z",
    fill: "#16192C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33464 4H8.66797V5.33333H7.33464V4ZM10.0013 4H11.3346V5.33333H10.0013V4ZM10.0013 6.68733H11.3346V8H10.0013V6.68733ZM10.0013 9.33333H11.3346V10.6667H10.0013V9.33333ZM4.66797 9.334H6.0013V10.6673H4.66797V9.334Z",
    fill: "#16192C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.b446e4f564b28ed783e88c201c2151a2.svg";
export { ForwardRef as ReactComponent };